export async function cacheFetch({ state, key, fetchFn, force = false, ttl }) {
  const now = Date.now();
  const value = state[key];
  const fetchedAt = state[`${key}FetchedAt`];
  const isStale = !fetchedAt || now - fetchedAt > ttl;

  if (!force && value && !isStale) {
    return value;
  }

  let result = null;

  try {
    result = await fetchFn();
    state[key] = result;
    state[`${key}FetchedAt`] = now;
  } catch (err) {
    state[key] = null;
    state[`${key}FetchedAt`] = null;
    throw err;
  }

  return result;
}

export function newCache(cacheTtl = 5 * 60 * 1000) {
  return (args = {}) => {
    return cacheFetch({ ttl: cacheTtl, ...args });
  };
}
